import { render } from "./pb-contactform.vue?vue&type=template&id=25012ede"
import script from "./pb-contactform.vue?vue&type=script&lang=js"
export * from "./pb-contactform.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__